import React, { Children } from 'react'
import classnames from 'classnames'

import styles from './Button.module.scss'

type ButtonProps<T extends React.ElementType> = {
  component?: T
  children?: React.ReactNode
  menuItem?: boolean
  text?: boolean
  plain?: boolean
  filled?: boolean
  small?: boolean
  tiny?: boolean
  loading?: boolean
  color?: string
  buttonRef?: React.Ref<T>
} & React.ComponentPropsWithoutRef<T>

function Button<T extends React.ElementType = 'button'>({
  component,
  children,
  menuItem,
  text,
  plain,
  filled,
  small,
  tiny,
  loading,
  color,
  className,
  style,
  type,
  buttonRef,
  ...elementProps
}: ButtonProps<T>) {
  const classNames = classnames(
    styles.Button,
    {
      [styles.standard]: !plain && !menuItem && !text,
      [styles.menuItem]: !plain && menuItem,
      [styles.text]: !plain && text,
      [styles.filled]: filled,
      [styles.small]: small,
      [styles.tiny]: tiny,
      [styles.loading]: loading,
    },
    className
  )

  const _style: any = { ...style }
  if (color) {
    _style['--color'] = color
  }

  const Component = component || 'button'

  return (
    <Component
      ref={buttonRef as any}
      className={classNames}
      style={_style}
      type={type || 'button'}
      {...elementProps}
      role={menuItem ? 'menuitem' : undefined}
    >
      {!plain && !menuItem && !text && (
        <div aria-hidden className={styles.baseline}>
          &nbsp;
        </div>
      )}
      {Children.map(children, (c) => (typeof c === 'string' || typeof c === 'number' ? <span>{c}</span> : c))}
    </Component>
  )
}

export default React.memo(Button) as typeof Button
